import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { apiBaseUrl } from "network"

export const productsApi = createApi({
    reducerPath: "productsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl, prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        updateProduct: builder.mutation({
            query: (body) => ({ url: "admin-product/update", method: "POST", body: body }),
        }),
        getAllProducts: builder.query({
            query: ({ page, limit, search, value, productType }) => ({
                url: `admin-product/products?page=${page}&limit=${limit}&search=${search}&id=${value}&productFor=${productType}`,
            }),
            transformResponse: (response) => response.data
        }),
        addProduct:builder.mutation({
            query:(body)=>({url:"admin-product/add_product",method:"POST",body:body})
        })
    })
})

export const { useGetAllProductsQuery, useUpdateProductMutation,useAddProductMutation } = productsApi
